
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/minu/sooduskoodid",
      function () {
        return require("private-next-pages/minu/sooduskoodid/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/minu/sooduskoodid"])
      });
    }
  